/*
 * Copyright (c) 2020 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {NavItem, NavLink} from 'reactstrap';


export default class NavBarLink extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    href: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    window.open(this.props.href, '_blank');
  }

  /**
   * Renders a 'reactstrap' NavItem for a Navbar.
   */
  render() {
    return (
        <NavItem>
          <NavLink role='button' onClick={this.onClick}>
            <FontAwesomeIcon icon={this.props.icon} />
            <span className="d-none d-sm-inline pl-1" aria-hidden="true">{this.props.title}</span>
          </NavLink>
        </NavItem>
    )
  }
}
